import React from "react";
import PropTypes from "prop-types";

const Bottom = (props) => {
  return (
    <div className="reisplanner__row reisplanner__row--bottom print-hide">
      <div className="reisplanner__row-transport-options">
        <div className="reisplanner__row">
          <div className="reisplanner__row-left">
            <div className="reisplanner__date">{props.children[0]}</div>
            <div className="reisplanner__time">{props.children[1]}</div>
            <div className="reisplanner__direction">{props.children[2]}</div>
          </div>
        </div>
        <div className="reisplanner__row">
          <div className="reisplanner__row-transport-options">
            <div className="reisplanner__row-left reisplanner__expandable">
              {props.children[3]}
            </div>
            <div className="reisplanner__row-left">{props.children[4]}</div>
          </div>
        </div>
      </div>

      <div className="reisplanner__row-right">
        <React.Fragment>
          {props.children[5]}
          {/*props.children[4]*/}
        </React.Fragment>
      </div>
    </div>
  );
};

Bottom.propTypes = {
  config: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
};

export default Bottom;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Group/ReisplannerBottom.js